import React from "react";
import localeText from "../../../../../../locale";

function getStrength(password) {
  if (!password) return { level: 0, labelKey: "passwordStrengthNone" };
  let score = 0;
  if (password.length >= 8) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[a-z]/.test(password)) score++;
  if (/\d/.test(password)) score++;
  if (/[^A-Za-z0-9]/.test(password)) score++;
  if (score <= 1) return { level: 1, labelKey: "passwordStrengthWeak" };
  if (score <= 3) return { level: 2, labelKey: "passwordStrengthMedium" };
  return { level: 3, labelKey: "passwordStrengthStrong" };
}

const PasswordStrengthIndicator = ({ password }) => {
  const { level, labelKey } = getStrength(password);
  const width = level === 0 ? 0 : level === 1 ? 33 : level === 2 ? 66 : 100;
  const color =
    level === 0
      ? "var(--theme-border)"
      : level === 1
        ? "#e57373"
        : level === 2
          ? "#ffb74d"
          : "var(--theme-primary)";

  return (
    <div className="mt-2">
      <div
        className="border-round overflow-hidden"
        style={{
          height: "8px",
          backgroundColor: "var(--theme-border)",
          width: "100%",
        }}
      >
        <div
          style={{
            width: `${width}%`,
            height: "100%",
            backgroundColor: color,
            transition: "width 0.2s",
          }}
        />
      </div>
      {/* <span className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
        {localeText(labelKey) ||
          (level === 0 ? "" : level === 1 ? "Fraca" : level === 2 ? "Média" : "Forte")}
      </span> */}
    </div>
  );
};

export default PasswordStrengthIndicator;
